<template>
  <div class="speaker columns">
    <img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteWebinar(webinarObject.id)"/>
    <div class="column">
      <div>
        <b-field label="Количество мест" class="count-wrapper">
          <b-input
            class="count"
            placeholder="0"
            v-model="webinarObject.places"
            @change="handleUpdateWebinar"
            type="number"
          ></b-input>
          <a class="button is-info" @click="showParticipants"
             v-if="webinarObject.webinarParticipants && webinarObject.webinarParticipants.length">
            Посмотреть {{ webinarObject.webinarParticipants.length }} {{ requestDeclension }}
          </a>
        </b-field>
      </div>
      <b-field label="Дата и время вебинара">
        <el-date-picker
          v-model="date"
          :editable="false"
          @change="dateChanged"
          type="datetime"
          placeholder="00:00">
        </el-date-picker>
      </b-field>
      <b-field label="Тема вебинара">
        <b-input placeholder="Напишите тему" v-model="webinarObject.theme" @change="handleUpdateWebinar"></b-input>
      </b-field>
      <b-field label="Ссылка">
        <b-input placeholder="Ссылка" v-model="webinarObject.link" @change="handleUpdateWebinar"></b-input>
      </b-field>
      <div v-if="webinarObject.webinarSpeaker">
        <b-field label="О чем вебинар" class="webinar-description">
          <Editor :editorToolbar="customToolbar" v-model="description" :id='"q" + webinarObject.id' placeholder=""/>
        </b-field>
        <b-field label="Выбрать спикера">
          <el-select  v-model="speaker" placeholder="Выбрать спикера"
                      @change="changeSpeaker">
            <el-option
              v-for="speaker in speakers"
              :key="speaker.id"
              :label="speaker.name"
              :value="speaker.id">
            </el-option>
          </el-select>
        </b-field>
      </div>
      <div class="webinar-meta" v-else>
        <div class="description-entry">
          <b-field label="Название доклада" class="webinar-description">
            <b-input v-model="presentation0" placeholder="Название доклада" @change="handleUpdateWebinar"></b-input>
          </b-field>
          <b-field label="Основные тезисы" class="webinar-description">
            <Editor :editorToolbar="customToolbar0" v-model="description0" :id='"q0" + webinarObject.id'
                    placeholder=""/>
          </b-field>
          <b-field label="Выбрать спикеров">
            <el-select v-model="selectedSpeakers0" multiple placeholder="Выбрать спикеров" class="centered"
                       @change="handleUpdateWebinar">
              <el-option
                v-for="speaker in speakers"
                :key="speaker.id"
                :label="speaker.name"
                :value="speaker.id">
              </el-option>
            </el-select>
          </b-field>
        </div>
        <div class="description-entry">
          <b-field label="Название доклада" class="webinar-description">
            <b-input v-model="presentation1" placeholder="Название доклада" @change="handleUpdateWebinar"></b-input>
          </b-field>
          <b-field label="Основные тезисы" class="webinar-description">
            <Editor :editorToolbar="customToolbar1" v-model="description1" :id='"q1" + webinarObject.id'
                    placeholder=""/>
          </b-field>
          <b-field label="Выбрать спикеров">
            <el-select v-model="selectedSpeakers1" multiple placeholder="Выбрать спикеров" class="centered"
                       @change="handleUpdateWebinar">
              <el-option
                v-for="speaker in speakers"
                :key="speaker.id"
                :label="speaker.name"
                :value="speaker.id">
              </el-option>
            </el-select>
          </b-field>
        </div>
      </div>

      <div class="switch-wrapper">
        <b-switch v-model="webinarObject.publishLater" @change="handleUpdateWebinar">Опубликовать позже</b-switch>
        <el-date-picker
          v-model="publishDate"
          :editable="false"
          @change="publishDateChanged"
          type="date"
          placeholder="00:00">
        </el-date-picker>
      </div>
      <div class="save-content-button centered">
        <div class="button save-content" @click="handleSaveWebinar">СОХРАНИТЬ</div>
      </div>
    </div>
    <el-dialog class="webinar-dialog" v-if="webinarObject.webinarParticipants"
               :visible.sync="dialogVisible"
    >
      <div class="webinar-participants">
        <span>
          {{ webinarObject.theme }}
        </span>
        <span>
          {{ formatedDate }}
        </span>
        <span class="webinar-participants-count">
          {{ webinarObject.webinarParticipants.length }} {{ requestDeclension }}
        </span>
        <table class="webinar-table">
          <tr v-for="participant in webinarObject.webinarParticipants">
            <td class="name"> {{ participant.name }}</td>
            <td> {{ participant.phone }}</td>
            <td> {{ participant.email }}</td>
          </tr>
        </table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import moment from 'moment'
import {VueEditor as Editor} from 'vue2-editor'

export default {
  name: 'Webinar',
  data() {
    return {
      updateTimer: 0,
      date: '',
      publishDate: '',
      description: '',
      description0: '',
      description1: '',
      selectedSpeakers0: [],
      selectedSpeakers1: [],
      presentation0: '',
      presentation1: '',
      speakerObj: null,
      speaker: null,
      inputVisible: false,
      inputValue: '',
      dialogVisible: false,
      formatedDate: '',
      customToolbar: [
        ['bold', 'italic', 'underline', 'link']
      ],
      customToolbar0: [
        ['bold', 'italic', 'underline', 'link']
      ],
      customToolbar1: [
        ['bold', 'italic', 'underline', 'link']
      ],
      meta: [
        {presentation: '', description: '', selectedSpeakers: []},
        {presentation: '', description: '', selectedSpeakers: []}
      ],
      webinarParticipants: [],
    }
  },
  computed: {
    ...mapState(['speakers']),
    webinarObject() {
      console.log('webinarObject', this.webinar)
      return this.webinar
    },
    requestDeclension() {
      if (this.webinarObject.webinarParticipants) {
        const number = this.webinarObject.webinarParticipants.length
        const titles = ['заявку', 'заявки', 'заявок']
        return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : [2, 0, 1, 1, 1, 2][(number % 10 < 5) ? number % 10 : 5]]
      }
    }
  },
  created() {

    this.date = this.webinar.date || ''
    this.publishDate = this.webinar.publishDate || ''

    this.description = this.webinar.description || '';

    // Ensure meta is an array with 2 objects
    this.meta = Array.isArray(this.webinar.meta) ? this.webinar.meta : [
      {description: '', presentation: '', selectedSpeakers: []},
      {description: '', presentation: '', selectedSpeakers: []}
    ]

    // Ensure meta array has at least 2 objects
    while (this.meta.length < 2) {
      this.meta.push({description: '', presentation: '', selectedSpeakers: []})
    }

    if (this.webinar.webinarSpeaker) {
      this.speaker = this.webinar.webinarSpeaker.id
      this.speakerObj = this.webinar.webinarSpeaker
    }

    this.selectedSpeakers0 = (this.meta[0].selectedSpeakers || []).map(speaker => speaker.id) || []
    this.selectedSpeakers1 = (this.meta[1].selectedSpeakers || []).map(speaker => speaker.id) || []

    this.description0 = this.meta[0].description || ''
    this.presentation0 = this.meta[0].presentation || ''
    this.description1 = this.meta[1].description || ''
    this.presentation1 = this.meta[1].presentation || ''

    this.formatedDate = this.date ? moment(this.date).format('LLL') : ''
  },
  props: {
    webinar: {
      type: Object,
      required: true
    }
  },
  methods: {
    ...mapActions(['saveWebinar', 'deleteWebinar', 'updateWebinar']),
    async handleUpdateWebinar() {
      if (!this.webinarObject.meta || !Array.isArray(this.webinarObject.meta)) {
        console.error("meta not properly defined");
        return;
      }

      let meta = [
        {
          description: this.description0,
          presentation: this.presentation0,
          selectedSpeakers: this.selectedSpeakers0.map(id => this.speakers.find(speaker => speaker.id === id))
        }
      ];

      if (this.presentation1.trim() !== '' || this.description1.trim() !== '') {
        meta.push({
          description: this.description1,
          presentation: this.presentation1,
          selectedSpeakers: this.selectedSpeakers1.map(id => this.speakers.find(speaker => speaker.id === id))
        });
      }

      this.webinarObject.description = this.description

      const updatedWebinarObject = {
        ...this.webinarObject,
        meta
      };

      await this.updateWebinar(updatedWebinarObject);
      this.updateLocalState(updatedWebinarObject);
    },
    async handleSaveWebinar() {
      if (!this.webinarObject.meta || !Array.isArray(this.webinarObject.meta)) {
        console.error("meta not properly defined");
        return;
      }

      let meta = [
        {
          description: this.description0,
          presentation: this.presentation0,
          selectedSpeakers: this.selectedSpeakers0.map(id => this.speakers.find(speaker => speaker.id === id))
        }
      ];

      if (this.presentation1.trim() !== '' || this.description1.trim() !== '') {
        meta.push({
          description: this.description1,
          presentation: this.presentation1,
          selectedSpeakers: this.selectedSpeakers1.map(id => this.speakers.find(speaker => speaker.id === id))
        });
      }

      this.webinarObject.description = this.description;

      const updatedWebinarObject = {
        ...this.webinarObject,
        meta
      };

      const savedWebinar = await this.saveWebinar(updatedWebinarObject);
      this.updateLocalState(savedWebinar);
      this.$emit('webinar-saved');
    },
    updateLocalState(newData) {
      this.webinarObject = {...newData}; // Присваиваем обновленные данные локальному состоянию компонента
    },
    showParticipants() {
      this.dialogVisible = true
    },
    dateChanged(data) {
      this.webinarObject.date = new Date(data)
      this.handleUpdateWebinar()
    },
    publishDateChanged(data) {
      this.webinarObject.publishDate = new Date(data)
      this.handleUpdateWebinar()
    },
    handleClose(tag) {
      this.dynamicTags.splice(this.webinarObject.tags.indexOf(tag), 1)
    },
    showInput() {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleInputConfirm() {
      let inputValue = this.inputValue
      if (inputValue) {
        this.webinarObject.tags.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    changeSpeaker(id) {
      const speaker = this.speakers.find(s => s.id === id)
      this.webinarObject.webinarSpeaker = speaker
      this.webinarObject['webinar_speaker_id'] = speaker.id
      this.speakerObj = speaker
      this.handleUpdateWebinar()
    },
  },
  components: {Editor},
  watch: {
    description(val) {
      this.description = val
      this.handleUpdateWebinar()
    },
    speakers(newSpeakers) {
      this.selectedSpeakers0 = this.selectedSpeakers0.filter(id => newSpeakers.some(speaker => speaker.id === id));
      this.selectedSpeakers1 = this.selectedSpeakers1.filter(id => newSpeakers.some(speaker => speaker.id === id));
      this.handleUpdateWebinar()
      this.handleSaveWebinar();
    }

  }
}
</script>


<style scoped>
.speaker {
  position: relative;
}

.speaker-select {
  flex-direction: column;
  height: 100%;
}

.el-select {
  margin: 0 auto;
}

.el-tag {
  margin-right: 10px;
}

.input-new-tag {
  margin: 10px 0;
}

.speaker-photo {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  margin: 0 0 15px;
}

.count-wrapper {
  display: initial !important;
}

.count {
  width: 192px;
  display: inline-block;
  margin: 0 13px 0.75rem 0 !important;
}

.switch-wrapper {
  flex-direction: row;
  justify-content: center;
}

.switch-wrapper .switch {
  margin: 0 15px;
}

.webinar-title {
  font-weight: bold;
  font-size: 16px;
}

.webinar-participants > span {
  display: block;
  text-align: center;
}

.webinar-participants-count {
  font-weight: bold;
  margin: 5px 0;
  font-size: 1.4em;
}

.webinar-table tr {
  border: 1px solid lightgray;
  border-radius: 5px;
  margin: 10px 0;
  display: block;
}

.webinar-table td {
  padding: 8px 14px;
  min-width: 150px;
  max-width: 33%;
}

.webinar-table .name {
  min-width: 200px;
  max-width: 200px;
  font-weight: bold;
}

.save-content {
  margin: 20px 0 0;
}

.webinar-meta {
  display: flex;
  justify-content: space-between;
}

.description-entry {
  width: 45%;
}

</style>
<style>
.webinar-wrapper .el-dialog {
  max-width: 620px;
}

.webinar-description .ql-editor {
  height: 150px;
}
</style>



// WEBPACK FOOTER //
// Webinar.vue?15f653e0